import { render } from "./PrivacyPolicy.vue?vue&type=template&id=3700a018&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=3700a018&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3700a018"

export default script